<script setup lang="ts">
import AvatarLoading from '@/assets/icons/Avatars/AvatarLoading.vue';
defineProps<{
  message?: string;
  generation?: boolean;
}>();
</script>

<template>
  <main class="mt-32 flex h-full w-full flex-col items-center justify-center gap-12">
    <h2 class="text-center">{{ message }}</h2>
    <div v-if="generation" class="w-4/5 md:w-1/5">
      <AvatarLoading />
    </div>
    <div v-else class="w-4/5 text-center md:w-1/5">
      <i class="pi pi-spin pi-spinner text-primary-500" style="font-size: 2rem"></i>
    </div>
  </main>
</template>
